import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";

export const professionLoader: LoaderFunction = async (args) => {
    if (args.params.professionCode === "new") {
        return new Promise((res) => res(Result.newResult()))
    }
    const result = await axiosApi.get("/api/professions/" + args.params.professionCode);
    return result.data
}